import React, { useEffect } from 'react';

import useTriggeredRequest from '@api/hooks/useTriggeredRequest';
import AccountClientRequests from '@api/requests';

import { getAccessToken, getIsLoggedIn, isVerificationAccount } from '@app/redux/auth/auth.selectors';
import { useAppSelector } from '@app/redux/hooks';

import { Grid } from '@mui/material';

import Loader from '@components/loader';

function AssetsProvider({ children }: { children: JSX.Element }) {
	const isLoggedIn = useAppSelector(getIsLoggedIn);
	const { isVerified } = useAppSelector(isVerificationAccount);
	const accessToken = useAppSelector(getAccessToken);

	const { startRequest: handleFetchRuleSets, isPending: isLoadingRuleSets } = useTriggeredRequest(
		AccountClientRequests.Assets.getRuleSets,
	);

	const { startRequest: handleFetchDocumentTypeList, isPending: isLoadingDocumentTypeList } = useTriggeredRequest(
		AccountClientRequests.Assets.getDocumentTypeList,
	);

	const { startRequest: handleFetchQuestionTypeList, isPending: isLoadingQuestionTypeList } = useTriggeredRequest(
		AccountClientRequests.Assets.getQuestionTypeList,
	);

	const { startRequest: handleFetchBranches, isPending: isLoadingBranches } = useTriggeredRequest(
		AccountClientRequests.Auth.getBranches,
	);

	useEffect(() => {
		if (isVerified && isLoggedIn && accessToken) {
			handleFetchBranches({ accessToken });
			handleFetchRuleSets();
			handleFetchDocumentTypeList();
			handleFetchQuestionTypeList();
		}
	}, [
		isVerified,
		accessToken,
		isLoggedIn,
		handleFetchBranches,
		handleFetchRuleSets,
		handleFetchDocumentTypeList,
		handleFetchQuestionTypeList,
	]);

	return isLoadingRuleSets || isLoadingDocumentTypeList || isLoadingQuestionTypeList || isLoadingBranches ? (
		<Grid container alignItems={'center'} justifyContent={'center'} sx={{ height: '100vh' }}>
			<Loader />
		</Grid>
	) : (
		children
	);
}

export default AssetsProvider;
